import { render, staticRenderFns } from "./LojistikIslemleri.vue?vue&type=template&id=29fd66f4"
import script from "./LojistikIslemleri.vue?vue&type=script&lang=js"
export * from "./LojistikIslemleri.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports